import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { stopEvent } from '@aytm/lib/common/func'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'
import ImagePin from '@aytm/lib/rfd-ui/components/basic/image-pin'
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'
import ImagePreview from '@aytm/app/survey/editor/components/content/assets/ImagePreview'

// styles
import style from '@aytm/app/swidget/questions/styles/common/swidget-image.module.scss'

export class SwidgetPinImage extends PureDataComponent {
  static propTypes = {
    picture: PropTypes.object,
    clickOnZoom: PropTypes.bool,
    text: PropTypes.string,
    noAltText: PropTypes.string
  }

  render() {
    const { picture, onLoad, imageCallback, hasLoaded, text, onClick, theme, withPincher = true, noAltText } = this.props
    const pinImage = picture.get('pin_image')
    const originalUrl = picture.get('original_url')
    const bigThumbnailUrl = picture.get('big_thumbnail_path')
    const thumbnail = picture.getIn(['thumbnail'])
    const proportion = picture.getIn(['proportion'])
    const scrolling = picture.get('scrolling')
    const altText = picture.get('alt_text') || noAltText

    return (
      <div className={style.fullsized}>
        {pinImage && originalUrl && (
          <ImagePin
            scrolling={scrolling}
            baseURL={originalUrl}
            previewURL={bigThumbnailUrl}
            label={text}
            altText={altText}
            clickOnZoom={true}
            withPopup={true}
            withZoom={true}
            onLoad={onLoad}
            hasLoaded={hasLoaded}
            onClick={onClick}
            mobile={'mobile' == theme}
            thumbnail={thumbnail}
            withPincher={withPincher}
            proportion={proportion}
            onZoomClick={'function' == typeof imageCallback ? imageCallback : null}
          />
        )}
      </div>
    )
  }
}

export class SwidgetImage extends PureDataComponent {
  static propTypes = {
    picture: PropTypes.object,
    theme: PropTypes.string,
    noAltText: PropTypes.string
  }

  constructor(...args) {
    super(...args)
    this.handlePincherCreate = this.handlePincherCreate.bind(this)
    this.handlePincherDestroy = this.handlePincherDestroy.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)
    this.renderPopupContent = this.renderPopupContent.bind(this)
  }

  componentDidMount() {
    if (this.refImagePin && 'function' === typeof this.refImagePin.addEventListener) {
      this.refImagePin.addEventListener('pincher:create', this.handlePincherCreate)
      this.refImagePin.addEventListener('pincher:destroy', this.handlePincherDestroy)
    }
  }

  componentWillUnmount() {
    if (this.refImagePin && 'function' === typeof this.refImagePin.removeEventListener) {
      this.refImagePin.removeEventListener('pincher:create', this.handlePincherCreate)
      this.refImagePin.removeEventListener('pincher:destroy', this.handlePincherDestroy)
    }
  }

  handlePincherCreate() {
    window.addEventListener('touchmove', this.handleTouchMove)
  }

  handlePincherDestroy() {
    window.removeEventListener('touchmove', this.handleTouchMove)
  }

  handleTouchMove(event) {
    stopEvent(event)
  }

  renderPopupContent(baseURL, previewURL, scrolling, altText) {
    return (
      <ImagePreview
        maxHeight="250px"
        maxWidth="250px"
        imageUrl={baseURL}
        previewUrl={previewURL}
        allowScrolling={scrolling}
        minHeight="50px"
        minWidth="50px"
        altText={altText}
      />
    )
  }

  render() {
    const { picture, theme, inFrame, accentColor, imageCallback, text, withPincher, noAltText } = this.props
    const pinImage = picture.get('pin_image')
    const scrolling = picture.get('scrolling')
    const originalUrl = picture.get('original_url')
    const bigThumbnailUrl = picture.get('big_thumbnail_path')
    const thumbnailUrl = picture.get('thumbnail_path')
    const withPopup = 'mobile' !== theme && !inFrame
    const altText = picture.get('alt_text') || noAltText

    return (
      <Fragment>
        {!pinImage && (
          <div className={`${style.thumbnail} ${'mobile' == theme ? style['thumbnail-mobile'] : ''}`}>
            {withPopup ? (
              <Popup
                portal={true}
                trigger="hover"
                direction="left"
                accentColor={accentColor}
                className={style.popup}
                contentStyle={{ borderRadius: '8px', padding: '2px', background: accentColor }}
                hideOtherPopupsOnShow={true}
                content={() => this.renderPopupContent(originalUrl, bigThumbnailUrl, scrolling, altText)}
                contentTheme="thin-black"
              >
                <ImagePin
                  scrolling={scrolling}
                  baseURL={originalUrl}
                  previewURL={thumbnailUrl}
                  clickOnZoom={false}
                  withPopup={true}
                  withZoom={true}
                  withPincher={withPincher}
                  mobile={'mobile' == theme}
                  label={text}
                  altText={altText}
                  zoomIcon={imageCallback ? 'icon-aytmfd-zoom-in' : 'no-icon'}
                  onZoomClick={'function' == typeof imageCallback ? imageCallback : null}
                />
              </Popup>
            ) : (
              <ImagePin
                ref={this.saveRef('ImagePin')}
                baseURL={originalUrl}
                previewURL={thumbnailUrl}
                // clickOnZoom={Boolean(imageCallback)}
                label={text}
                altText={altText}
                mobile={'mobile' == theme}
                withPopup={true}
                withZoom={true}
                clickOnImage={'mobile' == theme}
                withPincher={withPincher}
                zoomIcon={'no-icon'}
                onZoomClick={'function' == typeof imageCallback ? imageCallback : null}
              />
            )}
          </div>
        )}
      </Fragment>
    )
  }
}

export class SwidgetImagePlaceholder extends PureDataComponent {
  static propTypes = {
    theme: PropTypes.string
  }

  render() {
    const theme = this.props.theme
    return (
      <div
        className={`${style.thumbnail} ${style['thumbnail-placeholder']} ${
          'mobile' == theme ? style['thumbnail-mobile'] : ''
        }`}
      ></div>
    )
  }
}
